import { useState } from 'react';
import { getText } from '../api/client';

/** Fetches a TSV export and puts it on the clipboard, with the demo's flash feedback. */
export function CopyButton({
  label,
  url,
  done,
}: {
  label: string;
  url: string;
  done?: (text: string) => string;
}) {
  const [text, setText] = useState(label);
  const onClick = async () => {
    setText('Building…');
    try {
      const tsv = await getText(url);
      await navigator.clipboard.writeText(tsv);
      setText(done ? done(tsv) : 'Copied');
    } catch {
      setText('Copy blocked');
    }
    setTimeout(() => setText(label), 2000);
  };
  return (
    <button className="copy" type="button" onClick={onClick}>
      {text}
    </button>
  );
}

export function DownloadLink({ label, url }: { label: string; url: string }) {
  return (
    <a className="copy" href={url} download>
      {label}
    </a>
  );
}
